<template>
  <!-- 前端项目模板结构说明 -->
  <div class="frontProJect">
    <div class="frontProJect_nav card_style">
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleNav"
      >
        <el-menu-item index="fangzhou">方舟项目模板</el-menu-item>
        <el-menu-item index="admin">后台管理系统模板</el-menu-item>
      </el-menu>
    </div>
    <div class="frontProJect_content">
      <div class="content_left card_style">
        <h6>目录结构</h6>
        <div class="menu_box">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            accordion
            @node-click="handleTree"
            v-if="!isSet"
          >
          </el-tree>
          <p v-else>建设中...</p>
        </div>
      </div>
      <div class="content_right card_style">
        <div class="content_box" v-if="!isSet">
          <div>
            <div class="breadcrumb">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item
                  v-for="(title, index) in treeItemData.titles"
                  :key="index"
                >
                  {{ title }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div>
            <h6>描述：</h6>
            <div class="desc">{{ treeItemData.desc }}</div>
          </div>
          <div v-if="urls.length">
            <h6>例：</h6>
            <el-image
              v-for="(url, index) in urls"
              :key="index"
              :src="url"
              lazy
              :preview-src-list="urls"
            />
          </div>
          <div v-for="(item, index) in treeItemData.codes" :key="index">
            <h6>{{ item.title || "代码片段" }}：</h6>
            <div class="code_box">
              <highlightjs autodetect :code="item.code" />
            </div>
          </div>
        </div>
        <p v-else>建设中...</p>
      </div>
    </div>
  </div>
</template>

<script>
import menuData from "./menuData.js";

export default {
  data() {
    return {
      activeIndex: "fangzhou",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      treeItemData: {
        imgs: []
      },
      isSet: false
    };
  },
  computed: {
    urls() {
      return this.treeItemData.imgs.map(img => {
        return require("@/assets/img/frontProJect/" +
          this.activeIndex +
          "/" +
          img);
      });
    }
  },
  mounted() {
    this.treeData = menuData.fangzhou;
    this.treeItemData = this.treeData[0];
  },
  methods: {
    handleNav(e) {
      if (e == "fangzhou") {
        this.treeData = menuData.fangzhou;
        this.treeItemData = this.treeData[0];
        this.isSet = false;
      } else {
        this.treeData = [];
        this.treeItemData = {
          imgs: []
        };
        this.isSet = true;
      }
    },
    handleTree(e) {
      if (!!e.children && !e.children.length) {
        this.treeItemData = e;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.frontProJect {
  width: 100vw;
  height: 100vh;
  padding: 10px;
  box-sizing: border-box;
  color: #525f7f;
  background: #e7ebf1;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  &_nav {
    height: 50px;
    margin-bottom: 10px;
    overflow: hidden;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .el-menu--horizontal > .el-menu-item {
      height: 50px;
      line-height: 50px;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 3px solid #525f7f;
      color: #525f7f;
      font-weight: bold;
    }
  }
  &_content {
    height: 0;
    flex: 1;
    display: flex;
    > div {
      height: 100%;
    }
    .content_left {
      width: 300px;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      padding: 10px;
      box-sizing: border-box;
      > h6 {
        font-size: 14px;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 10px;
        padding-left: 10px;
        margin-bottom: 10px;
      }
      .menu_box {
        height: 0;
        flex: 1;
        overflow-y: scroll;
      }
    }
    .content_right {
      width: 0;
      flex: 1;
      padding: 15px;
      box-sizing: border-box;
      .content_box {
        width: 100%;
        height: 100%;
        overflow: scroll;
        > div {
          margin-bottom: 20px;
          > h6 {
            position: relative;
            padding-left: 10px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
            &::before {
              content: "";
              width: 3px;
              height: 70%;
              background: #525f7f;
              border-radius: 2px;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          > div {
            padding: 0 10px;
            box-sizing: border-box;
          }
          .breadcrumb {
            padding-left: 0;
          }
        }
      }
    }
  }
}
.card_style {
  background: #fff;
  border-radius: 6px;
  box-shadow: -3px 5px 5px 0px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/frontProJect/index.vue